import { MIN_PASSWORD_LENGTH } from '../../utils/constants';

export class PasswordValidator {

    static validatePassword(password: string): boolean {
        return PasswordValidator.isAboveMinLength(password) &&
            PasswordValidator.hasLowerAndUpperCase(password) &&
            PasswordValidator.hasNumber(password);
    }

    static isAboveMinLength(password: string): boolean {
        return password.length >= MIN_PASSWORD_LENGTH;
    }

    static hasLowerAndUpperCase(password: string): boolean {
        return /^(?=.*[a-z])(?=.*[A-Z])/.test(password);
    }

    static hasNumber(password: string): boolean {
        return /\d/.test(password);
    }
}


// WEBPACK FOOTER //
// ./src/webportal/services/validators/PasswordValidator.ts